import styled from 'styled-components';
import { Button } from '../Button';
import { ButtonVariants, type ButtonProps } from '../styles';

export type ToggleButtonProps = {
  selected: boolean;
  selectedVariant?: ButtonVariants;
  unselectedVariant?: ButtonVariants;
  /** Is part of a group, causes button to be dimmed */
  grouped?: boolean;
} & ButtonProps;

/** A selectable button (typically used for listings in ButtonGroup controls) */
export const ToggleButton = styled(
  ({
    selected,
    selectedVariant = ButtonVariants.Priority,
    unselectedVariant = ButtonVariants.Default,
    grouped = false,
    ...props
  }: ToggleButtonProps) => {
    const selectedProp = grouped ? { 'aria-selected': selected } : { 'aria-pressed': selected };
    return (
      <Button
        data-selected={selected}
        {...props}
        {...selectedProp}
        variant={selected ? selectedVariant : unselectedVariant}
      />
    );
  }
)``;
